import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = (measurementId) => {
  ReactGA.initialize(measurementId);
};

// Page view tracking
export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

// Event tracking
export const logEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};

// Create a compatibility layer for older 'ga' calls
// This will prevent the 'ga is not defined' error
window.ga = function() {
  const args = Array.prototype.slice.call(arguments);
  const command = args[0];
  
  // Map old ga commands to new gtag commands
  if (command === 'send' && args[1] === 'pageview') {
    logPageView();
  } else if (command === 'send' && args[1] === 'event') {
    const category = args[2] || '';
    const action = args[3] || '';
    const label = args[4] || '';
    const value = args[5] || 0;
    logEvent(category, action, label, value);
  }
  
  // Add more mappings as needed
};

export default {
  initGA,
  logPageView,
  logEvent
};